import { render, staticRenderFns } from "./ChartWithLastYearCompareFailedDelivery.vue?vue&type=template&id=2453f2e3&lang=pug&"
import script from "./ChartWithLastYearCompareFailedDelivery.vue?vue&type=script&lang=ts&"
export * from "./ChartWithLastYearCompareFailedDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./ChartWithLastYearCompareFailedDelivery.vue?vue&type=style&index=0&id=2453f2e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports